import styled from 'styled-components';

export const ChatingWrapper = styled.section`
  padding: 24px 16px;
`;

export const ChatListWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
